/* eslint-disable no-unused-vars */
import store from '@/store'

const setClassBasedOnState = {
  bind(el, binding) {
    const unwatch = store.watch((state, getters) => getters[binding.value.storeGetter], isActive => {
      if (binding.value.mediaQuery !== undefined) {
        if (store.getters['breakpoints'][binding.value.mediaQuery] && isActive) {
          el.classList.add(binding.value.setThisClass)
        } else {
          el.classList.remove(binding.value.setThisClass)
        }
      } else if (isActive) {
        if(binding.value.applyHidden) {
          el.removeAttribute('hidden')
        }

        // reflow - Force a browser re-paint so the browser will realize the
        // element is no longer `hidden` and allow transitions.
        const reflow = el.offsetHeight

        el.classList.add(binding.value.setThisClass)
      } else {
        el.classList.remove(binding.value.setThisClass)

        // setTimeout makes sure the css transition effect is finished before we apply the attribute
        if(binding.value.applyHidden) {
          setTimeout(() => {
            el.setAttribute('hidden', true)
          }, 300)
        }
      }
    }, { immediate: true })

    el.__isClassActive_unwatch__ = unwatch
  },
  unbind(el) {
    el.__isClassActive_unwatch__ && el.__isClassActive_unwatch__()
  }
}

export default setClassBasedOnState
